import { Button, Modal, Table } from 'flowbite-react';
import React, { useState } from 'react';
import { FaEdit, FaPlusCircle, FaTrash } from 'react-icons/fa';
import { Options } from '../components/options';
import { baseUrl } from '../config';



const PostSchedule = () => {
  const [tasks, setTasks] = useState([
    { id: 1, task: 'Scene 1', description: 'Shoot intro', location: 'Studio 1', dateTime: '2024-09-12 10:00 AM' },
    { id: 2, task: 'Scene 2', description: 'Outdoor scene', location: 'Park', dateTime: '2024-09-13 2:00 PM' },
  ]);
  
  const [newTask, setNewTask] = useState({ task: '', description: '', location: '', dateTime: '' });
  const [editingTask, setEditingTask] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask({ ...newTask, [name]: value });
  };

  // Add new task
  const addTask = () => {
    if (newTask.task && newTask.description && newTask.location && newTask.dateTime) {
      setTasks([...tasks, { ...newTask, id: tasks.length + 1 }]);
      setNewTask({ task: '', description: '', location: '', dateTime: '' });
      setIsAddModalOpen(false); // Close modal after adding task
    }
  };

  // Edit task
  const handleEdit = (task) => {
    setEditingTask(task);
  };

  // Update task
  const updateTask = () => {
    setTasks(tasks.map((t) => (t.id === editingTask.id ? editingTask : t)));
    setEditingTask(null);
  };

  // Delete task
  const handleDelete = (id) => {
    setTasks(tasks.filter((task) => task.id !== id));
  };

  // Handle edit input change
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingTask({ ...editingTask, [name]: value });
  };

  return (
    <div className='h-screen p-4 pl-0 flex'>
      <Options />
      <div className='mx-4'>
        <h2 className='text-4xl font-bold text-center mb-10'>Schedule</h2>
        <div className='flex justify-between items-center'>
            <p>Keep track of your schedules care free.</p>
            <div className="mb-6">
                <Button onClick={() => setIsAddModalOpen(true)} className="bg-green-500 text-white px-1 py-2 rounded-md hover:bg-green-600">
                    <FaPlusCircle className="mr-2 inline-block" /> Add Task
                </Button>
            </div>
        </div>
        

        {/* Schedule Table */}
        <div className="overflow-x-auto ">
          <Table>
            <Table.Head>
              <Table.HeadCell>Task</Table.HeadCell>
              <Table.HeadCell>Description</Table.HeadCell>
              <Table.HeadCell>Location</Table.HeadCell>
              <Table.HeadCell>Date & Time</Table.HeadCell>
              <Table.HeadCell></Table.HeadCell>
              <Table.HeadCell></Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {tasks.map((task) => (
                <Table.Row key={task.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                  <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                    {task.task}
                  </Table.Cell>
                  <Table.Cell>{task.description}</Table.Cell>
                  <Table.Cell>{task.location}</Table.Cell>
                  <Table.Cell>{task.dateTime}</Table.Cell>
                  <Table.Cell>
                    <button
                      className="text-blue-500 hover:text-blue-600"
                      onClick={() => handleEdit(task)}
                    >
                      <FaEdit />
                    </button>
                  </Table.Cell>
                  <Table.Cell>
                    <button
                      className="text-red-500 hover:text-red-600"
                      onClick={() => handleDelete(task.id)}
                    >
                      <FaTrash />
                    </button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>

        {/* Add Task Modal */}
        <Modal
          show={isAddModalOpen}
          size="md"
          popup={true}
          onClose={() => setIsAddModalOpen(false)}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="space-y-6">
              <h3 className="text-xl font-medium mb-3 text-gray-900">Add New Task</h3>
              <input
                type="text"
                name="task"
                placeholder="Task"
                value={newTask.task}
                onChange={handleInputChange}
                className="p-2 border rounded-md w-full mb-2"
              />
              <input
                type="text"
                name="description"
                placeholder="Description"
                value={newTask.description}
                onChange={handleInputChange}
                className="p-2 border rounded-md w-full mb-2"
              />
              <input
                type="text"
                name="location"
                placeholder="Location"
                value={newTask.location}
                onChange={handleInputChange}
                className="p-2 border rounded-md w-full mb-2"
              />
              <input
                type="text"
                name="dateTime"
                placeholder="Date & Time"
                value={newTask.dateTime}
                onChange={handleInputChange}
                className="p-2 border rounded-md w-full"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={addTask}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-green-600"
            >
              Add Task
            </Button>
            <Button
              onClick={() => setIsAddModalOpen(false)}
              color="gray"
              className="text-gray-600 px-4 py-2 rounded-md hover:text-gray-600"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Task Modal */}
        {editingTask && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold mb-4">Edit Task</h3>
              <div className="space-y-4">
                <input
                  type="text"
                  name="task"
                  value={editingTask.task}
                  onChange={handleEditChange}
                  className="p-2 border rounded-md w-full"
                />
                <input
                  type="text"
                  name="description"
                  value={editingTask.description}
                  onChange={handleEditChange}
                  className="p-2 border rounded-md w-full"
                />
                <input
                  type="text"
                  name="location"
                  value={editingTask.location}
                  onChange={handleEditChange}
                  className="p-2 border rounded-md w-full"
                />
                <input
                  type="text"
                  name="dateTime"
                  value={editingTask.dateTime}
                  onChange={handleEditChange}
                  className="p-2 border rounded-md w-full"
                />
                <div className="flex space-x-4">
                  <button
                    onClick={updateTask}
                    className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                  >
                    Update Task
                  </button>
                  <button
                    onClick={() => setEditingTask(null)}
                    className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostSchedule;

